import ControllerButton from '../base/controllerButton';

export default class ControllerButtonMenu extends ControllerButton {
  constructor(data, displayData) {
    super(data, displayData);

    this.addListener('pointertap', () => OPWrapperService.toggleSidebar())
  }
}
